import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ToastService } from 'src/app/shared/services/angular-service/toast.service';
import { LoginSignupService } from 'src/app/shared/services/node-api/login-signup.service';
import { UserService } from 'src/app/shared/services/node-api/user.service';

@Component({
  selector: 'app-profile-page-left-side-bar',
  templateUrl: './profile-page-left-side-bar.component.html',
  styleUrls: ['./profile-page-left-side-bar.component.scss']
})
export class ProfilePageLeftSideBarComponent implements OnInit {
  userName: any;
  plans = ['Free Plan'];
  plan: string;
  userImage: string = 'assets/images/icons/user.svg';
  imagePreview: string | ArrayBuffer | null = null;
  updateData = {};

  @ViewChild('fileInput') fileInput!: ElementRef<HTMLInputElement>;
  user: any;

  constructor(private loginSignupService: LoginSignupService,
    private toastService: ToastService,
    private userService: UserService
  ) { }

  ngOnInit(): void {
    this.userName = this.loginSignupService.getUserSession().user.name;
    this.plan = this.loginSignupService.getUserSession().user.plan;
    this.getUserData();
  }

  getUserData() {
    let currentOption;
    currentOption = {
      email: this.loginSignupService.getUserSession().user.email,
    };
    this.userService.userData(currentOption).then(
      (data: any) => {
        this.user = data;
        this.loginSignupService.setUserData(data);
        this.userImage = this.user.picture;

      },
      (err) => {
        console.log(err)
      }
    );
  }

  onFileChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files[0]) {
      const file = input.files[0];
      const reader = new FileReader();

      reader.onload = () => {
        this.imagePreview = reader.result;
        this.updateData = {
          id: this.user._id,
          picture: reader.result
        }
        this.updataUser();
      };
      reader.readAsDataURL(file);
    }
  }


  updataUser() {
    this.userService.updateUserProfile(this.updateData).then(
      (data: any) => {
        // console.log(data);
        this.userImage = data.picture;
        this.getUserData();
        this.toastService.addSingle(
          'success',
          'Successfully Updated',
          'You have successfully update your profile picture.'
        );
      },
      (err) => {
        this.toastService.addSingle('error', 'Error', err.error.message);
      }
    );
  }
}
